import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import UserLayout from "../page/component/UserLayout";

export default function NoAuthPage() {

  return (
    <UserLayout>
      <Container className="d-flex align-items-center" style={{ height: '100vh' }}>
        <Row>
          <Col>
            <Row style={{ width: '100vw' }}>
              <Col className="d-flex justify-content-center">
                <h3>对不起，您的登录已经过期</h3>
              </Col>
            </Row>
            <Row style={{ width: '100vw' }}>
              <Col className="d-flex justify-content-center">
                <h4>您可以尝试重新
                  <Button variant="outline-success">
                    <Link to="/login">登录</Link>
                  </Button>
                  后使用
                </h4>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </UserLayout>
  );
}